export const GET_TEAM_INIT = "TEAM:GET_INIT";
export const GET_TEAM_SUCCESS = "TEAM:GET_SUCCESS";
export const GET_TEAM_FAILURE = "TEAM:GET_FAIL";
